const all = (state) => state.preferences;

export default {
    all,
};
